import type { FolderType } from "~/types/folder";
import { FolderPreview } from "./FolderPreview";

type Props = {
  folders: FolderType[];
};

export const FolderPreviewList = ({ folders }: Props) => {
  return (
    <div className="mx-auto my-4 w-full mb-4 flex flex-wrap flex-col sm:flex-row gap-1">
      {folders.map((folder) => (
        <div className="flex-shrink-0 duration-500 animate-in fade-in" key={folder.id}>
          <FolderPreview folder={folder} />
        </div>
      ))}
    </div>
  );
};
